module.exports = __webpack_public_path__ + "img/healthcare.0c1becf6.jpg";